import { Component } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormGroup } from '@angular/forms';
import { ReorderEvent } from 'devextreme/ui/sortable';
import dxTagBox from 'devextreme/ui/tag_box';
import { delay, firstValueFrom, of, switchMap } from 'rxjs';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { EFormulaScope, EMPTY_TID, TechnicalFeature, ValueTypes } from 'src/app/models';

@Component({
    selector: 'app-products-technical-features-edit',
    templateUrl: './products-technical-features-edit.component.html',
    styleUrls: ['./products-technical-features-edit.component.css'],
    standalone: false
})
export class ProductsTechnicalFeaturesEditComponent extends GenericCrudEditComponent<TechnicalFeature> {

  override resource? = this.api.resources.product.technicalfeatures;
  valueTypes = ValueTypes.map(x => ({ id: x.id, name: this.translationService.instant(`enumeration.ValueTypes.${x.name}`) }));
  tagBoxValues?: dxTagBox;
  override displayEntity = () => this.entity!.name;

  protected override async preFetch(): Promise<void> {
    if (this.entity!.formulaId !== EMPTY_TID && this.entity!.formulaId) {
      const formula = await firstValueFrom(this.api.resources.product.formulas.get(this.entity!.formulaId));
      this.entity!.formula = formula.formula;
    }
  }

  override initFormGroup(): FormGroup {
    const technicalFeature: TechnicalFeature = this.entity!;

    const formulaValidator: AsyncValidatorFn = (control: AbstractControl) => {
      if (!control?.value) return of(null);
      return of(control.value).pipe(
        delay(800),
        switchMap(async (value)=> {
          const valid = await this.api.validateFormula(value, EFormulaScope.TechnicalFeature);
          return valid ? null : { invalidFormula: true };
        })
      )
    }

    const group = this.fb.group({
      id: [technicalFeature.id],
      code: [technicalFeature.code],
      name: [technicalFeature.name],
      valueTypeId: [technicalFeature.valueTypeId],
      values: [technicalFeature.values],
      formulaId: [technicalFeature.formulaId],
      formula: [technicalFeature.formula, [], [formulaValidator]],
    });
    return group;
  }

  reorder(e: ReorderEvent): void {
    const fromIndex = e.fromIndex;
    const toIndex = e.toIndex;
     this.form!.controls['values'].value.splice(toIndex, 0, this.form!.controls['values'].value.splice(fromIndex, 1)[0]);
    setTimeout(() => this.tagBoxValues?.repaint());
  }

  override async mapFormEntity(): Promise<TechnicalFeature> {
    const technicalFeature = this.form!.value as TechnicalFeature;
    if(!(technicalFeature.valueTypeId === 4 || technicalFeature.valueTypeId === 5)){
      technicalFeature.values = [];
    }
    return technicalFeature;
  }
}
